const FAQ_FILTER_SELECTOR = '[data-faq-filter]';
const FAQ_GROUP_SELECTOR = '[data-faq-group]';
const FAQ_OPEN_COLLAPSE_SELECTOR = '.cp-faq .accordion-collapse.show';

const collapseOpenFaqItems = () => {
	document.querySelectorAll( FAQ_OPEN_COLLAPSE_SELECTOR ).forEach( ( element ) => {
		const collapse = window.bootstrap?.Collapse?.getInstance( element );
		collapse?.hide();
	} );
};

const updateFilterState = ( buttons, activeFilter ) => {
	buttons.forEach( ( button ) => {
		const isActive = button.dataset.faqFilter === activeFilter;
		button.classList.toggle( 'is-active', isActive );
		button.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );
	} );
};

const updateGroupVisibility = ( groups, activeFilter ) => {
	groups.forEach( ( group ) => {
		const shouldShow = activeFilter === 'all' || group.dataset.faqGroup === activeFilter;
		group.classList.toggle( 'is-hidden', ! shouldShow );

		if ( shouldShow && group.hasAttribute( 'data-aos' ) ) {
			group.classList.add( 'aos-animate' );
		}
	} );
};

export const initFaqFilter = () => {
	const buttons = [ ...document.querySelectorAll( FAQ_FILTER_SELECTOR ) ];
	const groups = [ ...document.querySelectorAll( FAQ_GROUP_SELECTOR ) ];

	if ( ! buttons.length || ! groups.length ) {
		return;
	}

	const applyFilter = ( filter ) => {
		collapseOpenFaqItems();
		updateFilterState( buttons, filter );
		updateGroupVisibility( groups, filter );
		window.AOS?.refreshHard?.();
	};

	buttons.forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			applyFilter( button.dataset.faqFilter || 'all' );
		} );
	} );

	applyFilter( 'allgemein' );
};
